import { render, staticRenderFns } from "./edit-cmsCategory.vue?vue&type=template&id=346a1bcf"
import script from "./edit-cmsCategory.vue?vue&type=script&lang=ts"
export * from "./edit-cmsCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports